export default {
  API_APP_ID: 'tabacalera_website',
  API_URL: 'http://localhost:5000',
  FRONT_END_URL: 'http://localhost:3000',
  GA_TRACKING_ID: ''
};



// WEBPACK FOOTER //
// ./src/config/default.ts